import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { twoBtnPopupCreator, oneBtnPopupCreator } from '../popups/ConfirmPopup/helper';
import { extractSelectedInboxTab } from 'extractFromState';
import { getSelectedOrder } from 'selectors/tools';
import { SPECIALIST_ONLY_HINT } from 'constants/noteTypes';
import { temporaryUnlockSensitiveData, addNoteToSelectedTicket } from 'actions';
import get from 'lodash/get';
import { Row, ActionItem } from './ArrowButton.styles';

const ArrowButtonComponent = ({ label, onClickFunction, disabled = false, dataProtected, ...props }) => {
  const customerId = get(props, 'selectedOrder.customer.id');

  const onClick = () => {
    const {
      _addNoteToSelectedTicket,
      sensitiveDataType,
      selectedInboxTab,
      _temporaryUnlockSensitiveData,
      sensitiveData,
      isAdmin,
    } = props;
    const isDataUnlocked = get(sensitiveData, `[${customerId}][${label}][${sensitiveDataType}]`, false);

    if (dataProtected && !isDataUnlocked) {
      // prevent section from openning if the ticket isn't takken
      if (!['assigned', 'live_chat'].includes(selectedInboxTab) && !isAdmin) {
        return oneBtnPopupCreator({
          content: {
            main: 'Please take the ticket to access the data.',
            iconPath: '/images/x-green.svg',
          },
          btnConfig: 'CLOSE',
        });
      }

      return twoBtnPopupCreator({
        content: {
          main: `You're about to view customer's personal data. Are you sure?`,
          iconPath: '/images/green-alert-bell.svg',
        },
        btnConfig: {
          dismiss: 'Cancel',
          confirm: 'Confirm',
        },
        onConfirm: () => {
          const noteMessage = `Customer's ${sensitiveDataType} was viewed from ${label}`;

          _temporaryUnlockSensitiveData(sensitiveDataType, label, customerId);
          _addNoteToSelectedTicket(noteMessage, SPECIALIST_ONLY_HINT);

          return onClickFunction();
        },
      });
    }

    return onClickFunction();
  };

  return (
    <Row onClick={onClick} dataProtected={dataProtected}>
      <ActionItem>{label}</ActionItem>
    </Row>
  );
};

ArrowButtonComponent.propTypes = {
  label: PropTypes.string.isRequired,
  onClickFunction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  index: PropTypes.string,
};

const mapStateToProps = (state) => ({
  selectedInboxTab: extractSelectedInboxTab(state),
  sensitiveData: state.sensitiveData,
  isAdmin: state.user.isAdmin,
  selectedOrder: getSelectedOrder(state),
});

const mapDispatchToProps = (dispatch) => ({
  _addNoteToSelectedTicket: (message, noteType) => dispatch(addNoteToSelectedTicket(message, noteType)),
  _temporaryUnlockSensitiveData: (dataType, label, customerId) =>
    dispatch(temporaryUnlockSensitiveData(dataType, label, customerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArrowButtonComponent);
